// extracted by mini-css-extract-plugin
export default {"container":"NewProjectPage_container__ozPcb","content":"NewProjectPage_content__J2D78","column":"NewProjectPage_column__Bems0","row":"NewProjectPage_row__iqk++"};